import { useEffect } from 'react';

function pushDataLayer(data) {
  if (!window || !window.dataLayer) {
    console.info('GoogleTagManager is not ready');
  }
  window.dataLayer.push(data);
}

function pushPaymentTransaction(quote) {
  const risk = quote.coverages[0].risk;
  const toPay = quote.coverages[0].to_pay;
  const price = quote.coverages[0].premium;
  let policyType = '';

  if (risk.vehicle) {
    policyType = 'carcomprehensive';
  } else if (risk.item) {
    policyType = risk.item.type.toLowerCase();
  } else if (risk.pet) {
    policyType = 'pet';
  }

  pushDataLayer({
    event: 'salecomplete',
    transactionId: quote.quote_id,
    transactionTotal: toPay,
    transactionProducts: [
      {
        sku: policyType,
        name: policyType,
        payable_now: toPay,
        price: price,
        quantity: 1
      }
    ]
  });
}

const usePushCustomerDataEffect = ({ productType }) => {
  useEffect(() => {
    const data = {};

    let customerId = null;
    let risk = null;
    if (localStorage) {
      customerId = localStorage.getItem('cove-customer-id');
      risk = JSON.parse(localStorage.getItem('cove-risk'));
    }

    if (customerId) {
      data.userId = customerId;
    }

    if (productType) {
      data.productType = productType === 'vehicle' ? 'carcomprehensive' : 'pet';
    } else if (risk) {
      // as a last resort let's use the local storage
      data.productType = risk.vehicle ? 'vehicle' : 'pet';
    }

    pushDataLayer(data);
  }, []);
};

export { usePushCustomerDataEffect };

export default {
  pushDataLayer,
  pushPaymentTransaction
};
